module.exports = __webpack_public_path__ + "img/iconWoDeXiuGaiMiMa.5fe3ae02.svg";